<template>
  <BaseModal class="modal_video" v-on="$listeners">
    <BaseVideo v-bind="video" is-round />
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import BaseVideo from '@/components/BaseVideo.vue';

export default {
  name: 'TheVideoModal',
  components: {
    BaseModal,
    BaseVideo,
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="stylus">
.modal

  &_video

    & ^[0]__content
      width 100%
      max-width 100%
      padding 0
      background #000
      box-shadow none
      align-self center
      +landscape()
        max-width 80%
</style>
